
import { baseApi } from 'segments/api/baseApi';

import { EmailSettings, EmailSettingsServer, SmsService, SmsServiceServer, WorkTime } from './types';

export const Api = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSmsService: builder.query<SmsService, void>({
      query: () => '/admin/settings/sms',
      transformResponse: (res: SmsServiceServer) => ({
        apiKey: res.api_key,
        apiUrl: res.api_url
      }),
      providesTags: ['SMSServices']
    }),

    updateSmsService: builder.mutation<void, SmsService>({
      query: (body) => ({
        url: '/admin/settings/sms',
        method: 'PUT',
        body: {
          'api_key': body.apiKey,
          'api_url': body.apiUrl
        }
      }),
      invalidatesTags: ['SMSServices'],
    }),
    getEmailSetings: builder.query<EmailSettings, void>({
      query: () => '/admin/settings/email',
      transformResponse: ({ email_proxy_url, ...res }: EmailSettingsServer) => ({ emailProxyUrl: email_proxy_url, ...res }),
      providesTags: ['EmailSettings']
    }),

    updateEmailSetings: builder.mutation<void, EmailSettings>({
      query: ({ emailProxyUrl, ...body }) => ({
        url: '/admin/settings/email',
        method: 'PUT',
        body: {
          'email_proxy_url': emailProxyUrl,
          ...body
        }
      }),
      invalidatesTags: ['EmailSettings'],
    }),
    getWorkTime: builder.mutation<WorkTime, void>({
      query: () => '/opening_hours',
      invalidatesTags: ['WorkTime'],
    }),

    updateWorkTime: builder.mutation<void, WorkTime>({
      query: (body) => ({
        url: '/admin/settings/opening_hours',
        method: 'PUT',
        body
      }),
      invalidatesTags: ['WorkTime'],
    }),
  }),
});

export const {
  useGetSmsServiceQuery,
  useUpdateSmsServiceMutation,
  useGetEmailSetingsQuery,
  useUpdateEmailSetingsMutation,
  useUpdateWorkTimeMutation,
  useGetWorkTimeMutation
} = Api;
